<template>
  <div class="lpo-exam-data">
    <template>
      <div class="flex-container">
        <div class="flex-item">
          <div class="wrapper">
            <div class="address-block">
              <!-- //anton
                <div>
                <span>{{ lpoAddress }}</span>
              </div>
              -->
              <div
                v-if="selectedLpo && selectedLpo.section_lp"
                class="change-section-lp-block"
              >
                <span
                  v-if="!sectionLpEditMode"
                  class="change-section-lp-span"
                  :class="{ 'disable-click': !actLpoIsDraft}"
                  
                  @click="enableEditMode"
                  ><b>изменить номер лп выдела</b> <i class="fa fa-edit"></i
                ></span>
                <div class="edit-section-lp-block" v-else>
                  <span>Номер лп выдела</span>
                  <input v-model="editedSectionLp" class="section-lp-input" />
                  <button @click="saveSectionLp">Сохранить</button>
                  <button @click="disableEditMode">Отмена</button>
                </div>
              </div>
            </div>
            <template v-if="selectedLpo && selectedLpo.section_lp == null || (selectedLpo.section_lp != null &&(selectedLpo.s_lp > 0 || selectedLpo.s_lp_manual > 0)) || selectedLpo.inspection_type_id === '10'">
              <DataBlock title="Исполнитель обследования">
                <InspectionPerformer />
              </DataBlock>
              <DataBlock title="Дата проведения обследования">
                <InspectionDate />
              </DataBlock>

              <DataBlock title="Способ проведения обследования">
                <InspectionType />
              </DataBlock>

              <template v-if="lpoIsInstrum">
                <template
                  v-if="
                    selectedLpo.inspection_type_id === '4' ||
                      selectedLpo.inspection_type_id === '2'
                  "
                >
                  <DataBlock title="Визуальная оценка насаждения">
                    <InspectionTaxAccordanceVisual />
                  </DataBlock>
                </template>

                <DataBlock title="Перечет">
                  <InspectionRecount />
                  <PMessage v-if="['1','2','4'].includes(selectedLpo.inspection_type_id) && existEmptyPlots" severity="error" :closable="false">Заполнены не все площадки</PMessage>
                </DataBlock>

                <DataBlock title="Соответствие таксационных показателей">
                  <PMessage v-if="modelTreesAreOpen && modelTreesExist" severity="error" :closable="false">Необходимо закрыть редактирование списка модельных деревьев</PMessage>
                  <InspectionTaxAccordance v-else :key="NaN" />
                </DataBlock>

                <DataBlock title="Очаг">
                  <InspectionPestCore />
                </DataBlock>

                <DataBlock title="Мероприятия">
                  <PMessage v-if="modelTreesAreOpen && modelTreesExist" severity="error" :closable="false">Необходимо закрыть редактирование списка модельных деревьев</PMessage>
                  <PMessage v-if="plotList.length == 0" severity="error" :closable="false">Не добавлены площадки</PMessage>
                  <PMessage v-if="!selectedLpo.tax_accordance" severity="error" :closable="false">Не заполнен раздел Соответствие таксационных показателей</PMessage>
                  <InspectionMzl v-if="modelTreesExist && !modelTreesAreOpen && selectedLpo.tax_accordance" :key="NaN" />
                  
                </DataBlock>

                <template v-if="selectedLpo.need_visual === 't'">
                  <DataBlock title="Прогноз">
                    <InspectionForecast />
                  </DataBlock>

                  <DataBlock title="Загрязнения">
                    <InspectionPollutions />
                  </DataBlock>
                </template>
              </template>

              <template v-if="selectedLpo.inspection_type_id === '5'">
                <DataBlock title="Ведомость">
                  <InspectionRecount />
                </DataBlock>

                <DataBlock title="Соответствие таксационных показателей">
                  <InspectionTaxAccordance />
                </DataBlock>

                <DataBlock title="Очаг">
                  <InspectionPestCore />
                </DataBlock>

                <DataBlock title="Мероприятия">
                  <InspectionMzlBv />
                </DataBlock>

                <template v-if="selectedLpo.need_visual === 't'">
                  <DataBlock title="Прогноз">
                    <InspectionForecast />
                  </DataBlock>

                  <DataBlock title="Загрязнения">
                    <InspectionPollutions />
                  </DataBlock>
                </template>
              </template>

              <template v-if="selectedLpo.inspection_type_id === '6'">
                <DataBlock title="Ведомость аварийных деревьев">
                  <InspectionRecount />
                </DataBlock>

                <DataBlock title="Мероприятия">
                  <InspectionMzlWreck />
                </DataBlock>
              </template>
              <template v-if="selectedLpo.inspection_type_id === '7'">
                <DataBlock title="Ведомость">
                  <InspectionRecount />
                </DataBlock>
               
                  <DataBlock title="Соответствие таксационных показателей">
                    <InspectionTaxAccordance />
                  </DataBlock>

                  <DataBlock title="Очаг">
                    <InspectionPestCore />
                  </DataBlock>

                  <DataBlock title="Мероприятия">
                    <InspectionMzlVisualLand />
                  </DataBlock>

                  <DataBlock title="Прогноз">
                    <InspectionForecast />
                  </DataBlock>

                  <DataBlock title="Загрязнения">
                    <InspectionPollutions />
                  </DataBlock>
              </template>
              <template v-if="selectedLpo.inspection_type_id === '9'">
                <DataBlock title="Данные об использовании авиационных средств">
                  <InspectionAviaImageInfo />
                </DataBlock>
                <DataBlock title="Ведомость">
                  <InspectionRecount />
                </DataBlock>
                <DataBlock title="Мероприятия">
                    <InspectionMzlRemote />
                </DataBlock>
                <DataBlock title="Прогноз">
                    <InspectionForecastRemote />
                </DataBlock>
              </template>
              <template v-if="selectedLpo.inspection_type_id === '10'">
                <DataBlock title="Краткая характеристика материалов ДЗЗ">
                  <InspectionRemoteImageInfo />
                </DataBlock>
                <DataBlock title="Результаты дешифрирования">
                  <InspectionRecount />
                </DataBlock>
               
                  <DataBlock title="Соответствие таксационных показателей">
                    <InspectionTaxAccordance />
                  </DataBlock>


                  <DataBlock title="Мероприятия">
                    <InspectionMzlRemote />
                  </DataBlock>

                  <DataBlock title="Прогноз">
                    <InspectionForecastRemote />
                  </DataBlock>

                  <DataBlock title="Загрязнения">
                    <InspectionPollutions />
                  </DataBlock>
              </template>
            </template>
            <template v-else>
              <PMessage severity="error" :closable="false">Для продолжения необходимо ввести площадь лесопатологического выдела</PMessage>
            </template>
            <div class="links-block">
              <router-link :to="linkPrev"><- Назад - Границы и площадь выдела</router-link>
              <router-link class='right' :to='linkNext'>Далее - Результаты обследования -></router-link>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import DataBlock from "../CurrentLpo__dataBlock";
import InspectionPerformer from "./CurrentLpo__inspectionPerformer";
import InspectionDate from "./CurrentLpo__inspectionDate";
import InspectionType from "./CurrentLpo__inspectionType";
import InspectionTaxAccordanceVisual from "./CurrentLpo__taxAccordanceVisual";
import InspectionRecount from "./CurrentLpo__recount";
import InspectionTaxAccordance from "./CurrentLpo__taxAccordance";
import InspectionPestCore from "./CurrentLpo__pestCore";
import InspectionMzl from "./CurrentLpo__mzl";
import InspectionMzlBv from "./CurrentLpo__mzlBv";
import InspectionMzlWreck from "./CurrentLpo__mzlWreck";
import InspectionForecast from "./CurrentLpo__forecast";
import InspectionForecastRemote from "./CurrentLpo__forecastRemote";
import InspectionPollutions from "./CurrentLpo__pollutions";
import InspectionMzlVisualLand from "./CurrentLpo__mzlVisualLand";
import InspectionMzlRemote from "./CurrentLpo__mzlRemote";
import InspectionRemoteImageInfo from "./CurrentLpo__remoteImageInfo";
import InspectionAviaImageInfo from "./CurrentLpo__aviaImageInfo";

export default {
  name: "LpoExamData",
  components: {
    DataBlock,
    InspectionPerformer,
    InspectionDate,
    InspectionType,
    InspectionTaxAccordanceVisual,
    InspectionRecount,
    InspectionMzlVisualLand,
    InspectionMzlRemote,
    InspectionTaxAccordance,
    InspectionPestCore,
    InspectionMzl,
    InspectionMzlBv,
    InspectionMzlWreck,
    InspectionForecast,
    InspectionForecastRemote,
    InspectionPollutions,
    InspectionRemoteImageInfo,
    InspectionAviaImageInfo
  },
  data() {
    return {
      sectionLpEditMode: false,
      editedSectionLp: null,
    };
  },
  computed: {
    existEmptyPlots() {
      let flag = false;
      if (this.plotList) {
        this.plotList.forEach(element => {
          if(element.trees_count == '0' || element.trees_count == null) {
            flag = true;
          }
        });
      }
      return flag;
    },
    ...mapGetters('selectedLpo/recount', [
				'modelTreesAreOpen',
				'modelTreesExist',
		]),
    ...mapGetters('lpoData', ['actLpoIsDraft'
		]),
    speciesListVisual() {
      if (!this.visualSpeciesList.length) {
        return [];
      }
      if (!this.visualSpeciesList.find(item => item.tax_species_id)) {
        return [];
      }

      return this.visualSpeciesList.filter(item => {
        return item.tax_species_id; 
      }).map(item => {
        return {
          coeff: item.coeff,
          species: item.species_name,
          layer: item.layer,
          species_id: item.species_id,
          gen: item.gen
        }
      });
		},
    bvListCheck() {
      const species = this.speciesTaxNotAccord ? this.speciesListVisual : this.$store.state.selectedLpo.recount.speciesListTax;
      const list = this.$store.state.selectedLpo.recount.vbList;
      if(list != undefined) {
        return list.map(item => +item.trees_proc).reduce((partialSum, a) => partialSum + a, 0) == 100*species.length;
      } else {
        return false;
      }
    },
    lpoIsInstrum() {
      return (
        this.selectedLpo.inspection_type_id === "1" ||
        this.selectedLpo.inspection_type_id === "2" ||
        this.selectedLpo.inspection_type_id === "3" ||
        this.selectedLpo.inspection_type_id === "4"
      );
    },

    linkPrev() {
      return { name: "current-lpo-geometry" };
    },
    linkNext() {
      return { name: "current-lpo-result" };
    },

    ...mapState("selectedLpo", {
      selectedLpo: (state) => state.lpo,
      visualSpeciesList: state => state.visualSpeciesList,
    }),
    ...mapState("selectedLpo/recount", {
      plotList: (state) => state.plotList,
    }),
    ...mapGetters("selectedLpo", ["lpoAddress"]),
    ...mapGetters('selectedLpo', ['speciesTaxNotAccord']),
  },
  methods: {
    enableEditMode() {
      this.editedSectionLp = this.selectedLpo.section_lp;

      this.sectionLpEditMode = true;
    },
    disableEditMode() {
      this.sectionLpEditMode = false;
    },

    saveSectionLp() {
      if (this.editedSectionLp === null || this.editedSectionLp === "") {
        this.$toast.add({
          severity: "warn",
          detail: "Нужно указать номер лп выдела",
          life: 10000,
        });
        return;
      }

      const temp = [
        {
          field: "section_lp",
          value: this.editedSectionLp,
        },
      ];

      this.saveLpoValue(temp)
        .then((res) => {
          this.updateLpo();
          this.disableEditMode();
        })
        .catch((err) => {
          if (err.message === "23505") {
            this.$toast.add({
              severity: "warn",
              detail: "Лп выдел с таким номером уже существует",
              life: 10000,
            });
          } else {
            throw err;
          }
        });
    },

    ...mapActions("selectedLpo", ["saveLpoValue", "updateLpo"]),
  },
  created() {
  }
};
</script>

<style scoped src="@/style/flex.css"></style>
<style scoped src="@/style/wrapper.css"></style>

<style scoped>
.data-block {
  margin-bottom: 5rem;
}

.change-section-lp-block {
  margin-top: 10px;
}

.change-section-lp-span {
  font-size: 18px;
  cursor: pointer;
  color: #d13e3e;
  text-decoration: underline;
}
.change-section-lp-span:hover {
  color: #666;
}

.section-lp-input {
  width: 100px;
}

.edit-section-lp-block > * {
  margin-right: 10px;
}
.edit-section-lp-block > button {
  margin-right: 4px;
}
.right {
		float: right;
	}
.disable-click{
  pointer-events: none;
}
</style>
